import React from 'react';
import NavMenu from './NavMenu';

export default function Layout({ navLinks, className, children })  {
    return (
        <div className={className}>
            <NavMenu navLinks={navLinks} />
            <div className='relative h-container w-full'>
                {children}
            </div>
        </div>
    );
}
